import $ from 'jquery';
import List from 'list.js';
import {Filterable} from "javascripts/lib/store/concerns/filterable";
import {Sortable} from "javascripts/lib/store/concerns/sortable";

export const Listable = (superclass) => class extends Filterable(Sortable(superclass)) {
  actsAsList(options) {
    let defaultOptions = {
      filterOn: [],
      features: {
        filtering: false,
        sorting: false,
        textToggling: false
      }
    };
    options = $.extend({}, defaultOptions, options, true);
    // initialize a List to manage adding/removing list items from the DOM
    // see: https://listjs.com for docs
    this.list = new List(this.$el.get(0), {
      listClass: this.$el.children('ul').attr('class'),
      valueNames: [{data: options.filterOn}]
    });

    this.actsAsFilterable(options.features.filtering);
    this.actsAsSortable(options.features.sorting);
  }
};
